import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 text-center text-sm text-sub bg-dark border-t border-divider" data-id="element-57">
        <p className="mb-3" data-id="element-58">
          © {new Date().getFullYear()} The Reset Protocol. Todos los derechos
          reservados.
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-59">
          <button onClick={() => setActiveModal('privacy')} className="text-sub hover:text-gold transition-colors underline underline-offset-2" data-id="element-60">
            Política de Privacidad
          </button>
          <span className="text-divider" data-id="element-61">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-sub hover:text-gold transition-colors underline underline-offset-2" data-id="element-62">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-63">
          <div className="bg-dark-100 border border-gold/20 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto relative" onClick={e => e.stopPropagation()} data-id="element-64">
            <div className="sticky top-0 bg-dark-100 border-b border-divider px-6 py-4 flex items-center justify-between z-10" data-id="element-65">
              <h2 className="text-lg font-serif font-bold text-body" data-id="element-66">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="text-sub hover:text-gold transition-colors p-1" data-id="element-67">
                <XIcon className="w-5 h-5" data-id="element-68" />
              </button>
            </div>

            <div className="px-6 py-6 text-sm text-sub leading-relaxed space-y-4" data-id="element-69">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-70" /> : <TermsContent data-id="element-71" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-body font-bold text-base" data-id="element-72">Política de Privacidad</p>
      <p data-id="element-73">Última actualización: Marzo 2026</p>

      <p className="text-body font-medium mt-4" data-id="element-74">
        1. Información que Recopilamos
      </p>
      <p data-id="element-75">
        Recopilamos información personal que nos proporcionas directamente al
        realizar una compra, incluyendo tu nombre, dirección de correo
        electrónico e información de pago. No almacenamos datos de tarjetas de
        crédito directamente; estos son procesados por nuestros proveedores de
        pago seguros.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-76">2. Uso de la Información</p>
      <p data-id="element-77">
        Utilizamos tu información para procesar tu compra, enviarte acceso al
        producto digital, comunicarnos contigo sobre tu pedido y enviarte
        actualizaciones relacionadas con The Reset Protocol. No vendemos ni
        compartimos tu información personal con terceros para fines de
        marketing.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-78">3. Protección de Datos</p>
      <p data-id="element-79">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, pérdida o
        alteración.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-80">4. Cookies</p>
      <p data-id="element-81">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-82">5. Tus Derechos</p>
      <p data-id="element-83">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, contáctanos a través
        de los canales proporcionados en tu email de confirmación de compra.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-84">6. Cambios a esta Política</p>
      <p data-id="element-85">
        Nos reservamos el derecho de actualizar esta política en cualquier
        momento. Los cambios serán publicados en esta página con la fecha de
        actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-body font-bold text-base" data-id="element-86">Términos y Condiciones</p>
      <p data-id="element-87">Última actualización: Marzo 2026</p>

      <p className="text-body font-medium mt-4" data-id="element-88">
        1. Aceptación de los Términos
      </p>
      <p data-id="element-89">
        Al acceder y realizar una compra en este sitio, aceptas estos términos y
        condiciones en su totalidad. Si no estás de acuerdo con alguno de estos
        términos, no debes utilizar este sitio ni adquirir nuestros productos.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-90">2. Producto Digital</p>
      <p data-id="element-91">
        The Reset Protocol es un producto digital que incluye archivos PDF y
        audios de meditación. Al completar tu compra, recibirás acceso inmediato
        al contenido a través de un enlace enviado a tu correo electrónico.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-92">3. Garantía de 7 Días</p>
      <p data-id="element-93">
        Ofrecemos una garantía de devolución de 7 días. Si después de completar
        los primeros 7 días del protocolo exactamente como indica la guía no
        sientes una diferencia real, te devolvemos el 100% de tu pago. Para
        solicitar un reembolso, contacta a nuestro equipo a través del email de
        soporte proporcionado en tu confirmación de compra.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-94">4. Uso Personal</p>
      <p data-id="element-95">
        El contenido adquirido es para uso personal exclusivamente. Queda
        prohibida la reproducción, distribución o reventa del material sin
        autorización expresa por escrito.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-96">
        5. Descargo de Responsabilidad
      </p>
      <p data-id="element-97">
        The Reset Protocol es un programa de bienestar y desarrollo personal. No
        sustituye el consejo médico profesional, diagnóstico o tratamiento.
        Consulta siempre a un profesional de la salud calificado ante cualquier
        condición médica.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-98">6. Precios</p>
      <p data-id="element-99">
        Los precios están sujetos a cambios sin previo aviso. El precio vigente
        al momento de tu compra será el precio que se te cobrará. Las ofertas
        promocionales tienen duración limitada y pueden ser retiradas en
        cualquier momento.
      </p>

      <p className="text-body font-medium mt-4" data-id="element-100">7. Ley Aplicable</p>
      <p data-id="element-101">
        Estos términos se rigen por las leyes aplicables en la jurisdicción
        correspondiente. Cualquier disputa será resuelta mediante los mecanismos
        legales apropiados.
      </p>
    </>;
}